import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import envConfig from "../../../config";
import { setCrossDomainCookie } from "../../../utils/cookie-utils";
import {
  authxAppsBase,
  getLoginVerificationRedirect,
  isAuthxLoginSessionUsable,
  loginAuthxHeadersPreSession,
  normalizeAuthxSession,
  persistAuthxSessionCookies,
  persistPendingVerificationState,
} from "../../../utils/authx-login-helpers";

const VerifyEmailHash = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const email = searchParams.get("email");

    const fetchData = async () => {
      try {
        const response = await fetch(
          `https://${envConfig.apiDev1}/api/v3/en-au/users/find-by-email-verification-hash?sendsmsYN=Y&hash=${email}&BaseHostURL=${envConfig.loginUrl}`,
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              "olivs-api-real-ip": "115.70.37.103",
              "olivs-api-computer-name": "EC2AMAZ-QF1CQAD",

              "api-key": "OlivsAuth",
            },
          }
        );
        const data = await response.json();

        if (data?.SuccessYN === "Y") {
          try {
            const loginUrl = `${authxAppsBase()}/login`;
            const generateTokenResponse = await fetch(loginUrl, {
              method: "POST",
              headers: loginAuthxHeadersPreSession("115.70.37.103"),
              body: JSON.stringify({
                loginHash: data?.LoginSecuredHash,
              }),
            });

            const generateTokenJson = await generateTokenResponse.json();
            const sess = normalizeAuthxSession(generateTokenJson);
            const verificationRedirect = getLoginVerificationRedirect(sess);

            if (
              !isAuthxLoginSessionUsable(
                generateTokenResponse.ok,
                sess,
                verificationRedirect,
              )
            ) {
              throw new Error("AuthX login failed after email verification");
            }

            persistAuthxSessionCookies(
              generateTokenJson,
              data?.LoginEmail || "",
            );
            setCrossDomainCookie("loginSecuredHash", data?.LoginSecuredHash);
            setCrossDomainCookie("databaseId", "0");

            const approveEmailUrl = `https://${envConfig.apiDev1}/api/v3/en-au/users/approve-login-email?BaseHostURL=${envConfig.loginUrl}`;

            const approveEmailData = JSON.stringify({
              LoginSecuredHash: data?.LoginSecuredHash,
            });

            const approveHeaders = {
              "Content-Type": "application/json",
              Accept: "application/json",
              "olivs-api-real-ip": "115.70.37.103",
              "olivs-api-computer-name": "EC2AMAZ-QF1CQAD",
              "api-key": "OlivsAuth",
            };

            const approveEmailResponse = await fetch(approveEmailUrl, {
              method: "POST",
              headers: approveHeaders,
              body: approveEmailData,
            });
            await approveEmailResponse.json();

            setCrossDomainCookie(
              "globalUserId",
              String(sess.globalUserId || data?.GlobalUserId || ""),
            );

            setCrossDomainCookie("emailVerified", "Y");

            if (verificationRedirect) {
              persistPendingVerificationState(sess, data?.LoginSecuredHash);
            }

            if (verificationRedirect === "email") {
              navigate("/verify-email", {
                state: {
                  firstName: sess.firstName,
                  email: data?.LoginEmail || "",
                  loginSecured: data?.LoginSecuredHash,
                  accessKey: sess.accessKey,
                  refreshKey: sess.refreshKey,
                },
              });
            } else if (verificationRedirect === "phone") {
              navigate("/verify-phone", {
                state: {
                  loginSecuredHash: data?.LoginSecuredHash,
                  ...(data?.Phone ? { phone: data.Phone } : sess.mobPhoneNo ? { phone: sess.mobPhoneNo } : {}),
                  accessKey: sess.accessKey,
                  refreshKey: sess.refreshKey,
                },
              });
            } else {
              navigate("/mfa", {
                state: {
                  email: data?.LoginEmail || "",
                  accessKey: sess.accessKey,
                  refreshKey: sess.refreshKey,
                  ip: "115.70.37.103",
                  loginSecuredHash: data?.LoginSecuredHash,
                },
              });
            }
          } catch (error) {
            console.error("Error:", error);
            navigate("/");
          }
        } else {
          navigate("/");
        }
      } catch (error) {
        console.error("Error fetching data:", error);

        navigate("/");
      }
    };

    if (email) {
      fetchData();
    } else {
      navigate("/");
    }
  }, [navigate, location.search]);

  return null;
};

export default VerifyEmailHash;
